import React from 'react';
import {
  Box,
  Typography,
  Flex,
  colors,
  useI18nContext,
  LinkButton,
} from '@procore/core-react';
import styled from 'styled-components';
import { Divider } from '@/react/styles';
import { NAVIGATION_MENU_ITEMS } from '@/react/consts';

const BodyContainer = styled(Box)`
  background-color: ${colors.gray96};
  flex-grow: 1;
  height: 100%;
`;

const MenuItem = styled(LinkButton)`
  align-items: center;
  justify-content: flex-start;
`;

const MenuBody = () => {
  const i18n = useI18nContext();
  return (
    <BodyContainer paddingLeft="lg">
      <Box display="block" paddingTop="md" paddingBottom="sm">
        <Typography className="font-size-h2" weight="semibold">
          {i18n.t('navbar.supportCenter')}
        </Typography>
      </Box>

      <Divider color={colors.gray90} />

      <Flex direction="column" gap="sm">
        {NAVIGATION_MENU_ITEMS.map((item) => (
          <MenuItem
            key={item.href}
            href={item.href}
            block
            variant="tertiary"
            role="link"
            size="md"
          >
            <Typography
              intent="body"
              weight="semibold"
              className="font-size-body"
            >
              {i18n.t(item.label)}
            </Typography>
          </MenuItem>
        ))}
      </Flex>
    </BodyContainer>
  );
};

export default MenuBody;
